import script from "./TestNotificationView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestNotificationView.vue?vue&type=script&setup=true&lang=js"

import "./TestNotificationView.vue?vue&type=style&index=0&id=42e2c313&lang=css"

const __exports__ = script;

export default __exports__